import axios from "@/plugins/axios";
import { ActionTree } from "vuex";
import { RootState } from "../types";
import { HomeState } from "./types";

export const actions: ActionTree<HomeState, RootState> = {
  getGraphData({ state }, { config, p }) {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    let sites;

    if (Array.isArray(config.site)) {
      sites = config.site.map((si: any) => si.restaurantId).toString();
    } else {
      sites = config.site.restaurantId;
    }
    let datePerso = config.date;
    if (p === 1) {
      datePerso = config.dateLastWeek;
    } else if (p === 2) {
      datePerso = config.dateLastYear;
    }

    let url =
      `bo/home/${config.WS}?id=${userId}&sites=${sites}&datePerso=${datePerso}&cache=` +
      Date.now();
    if (user.codeExploitant) {
      url += "&exploitant=" + user.codeExploitant;
    }
    // console.log(url);
    return axios
      .get(url)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  getGraphDataTotal({ state }, config) {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    const sites: string[] = [];

    if (Array.isArray(config.site)) {
      config.site.forEach((si: any) => {
        sites.push(si.restaurantId);
      });
    } else {
      sites.push(config.site.restaurantId);
    }

    const url =
      `bo/home/${config.WS}?id=${userId}&sites=${sites}&datePerso=${config.date}&cache=` +
      Date.now();
    /*if (state.rapport.lSites !== undefined && state.rapport.lSites.length > 0) {
      url += `&sites[]=`;
      for (const site of state.rapport.lSites) {
        url = url + `${site.libelle},`;
      }
      url = url.substring(0, url.length - 1);
    }*/

    // console.log(url);
    return axios
      .get(url)
      .then(
        (response) => {
          return response.data;
        },
        (error) => {
          throw new Error(JSON.stringify(error));
        }
      )
      .catch((error) => {
        const myerror = { message: error.message, status: error.status, error };
        throw new Error(JSON.stringify(myerror));
      });
  },
  async getHomeData({ state }, { config, WS, year, week }) {
    console.log("getHomeData action called");
    console.log(config, WS, year, week);

    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    if (WS === undefined) {
      return;
    }
    let datePerso = config.date;
    if (year || week) {
      datePerso = config.dateLastYear;
    }
    // console.log(WS, datePerso, week);
    let sites;
    if (Array.isArray(config.site)) {
      sites = config.site.map((si: any) => si.restaurantId).toString();
    } else {
      sites = config.site.restaurantId;
    }
    let url =
      `bo/home/${WS}?id=${userId}&sites=${sites}&datePerso=${datePerso}&cache=` +
      Date.now();
    /*if (config.profit !== []) {
      url += `&profit=${config.profit}`;
    }*/
    /*if (config.localisation !== "") {
      url += `&localisation=${config.localisation}`;
    }*/
    if (user.codeExploitant) {
      url += `&exploitant=${user.codeExploitant}`;
    }
    if (config.service !== "") {
      url += `&service=${config.service}`;
    }
    if (config.horodatage !== "") {
      url += `&horodatage=${config.horodatage}`;
    }
    if (config.horotage) {
      url += `&heureCourante=true`;
    } else {
      url += `&heureCourante=false`;
    }
    url += `&client=${config.client}`;
    // console.log(url);
    return await axios
      .get(url)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  async getHomeDataV2({ state, rootGetters }, { config, WS, year, week }) {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;

    if (WS === undefined) {
      return;
    }

    let datePerso = config.date;
    if (year || week) {
      datePerso = config.dateLastYear;
    }

    let sites: number[];
    if (Array.isArray(config.site)) {
      sites = config.site.map((si: any) => si.restaurantId);
    } else {
      sites = [config.site.restaurantId];
    }

    let url = `bo/home/V2/getAllDataByProfit?`;

    // Paramètres requis pour V2
    const params = new URLSearchParams();
    params.append("datesFiscales", datePerso);
    params.append("restaurantIds", sites.join(", "));

    url += params.toString();

    return await axios
      .get(url)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  async getHomeDataSimple({ state }, { date, WS, site }) {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    if (WS === undefined) {
      return;
    }
    const url =
      `bo/home/${WS}?id=${userId}&sites=${site}&datePerso=${date}&cache=` +
      Date.now();
    return await axios
      .get(url)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  async getCAVendeurs({ state }, { config, WS }) {
    // console.log(config, WS);
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    if (WS === undefined) {
      return;
    }
    let sites;
    if (Array.isArray(config.site)) {
      sites = config.site.map((si: any) => si.restaurantId).toString();
    } else {
      sites = config.site.restaurantId;
    }
    let url =
      `bo/home/${WS}?id=${userId}&sites=${sites}&datePerso=${config.date}&vendeurs='${config.vendeur}'&cache=` +
      Date.now();

    if (user.codeExploitant) {
      url += `&exploitant=${user.codeExploitant}`;
    }
    if (config.service !== "") {
      url += `&service=${config.service}`;
    }
    return await axios
      .get(url)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  async getServiceHomeData({ state }, { config, WS }) {
    // console.log(config, WS);
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    if (WS === undefined) {
      return;
    }
    let sites;
    if (Array.isArray(config.site)) {
      sites = config.site.map((si: any) => si.restaurantId).toString();
    } else {
      sites = config.site.restaurantId;
    }
    let url = `bo/home/${WS}?id=${userId}&sites=${sites}&datePerso=${config.date}`;

    if (config.service !== "" && config.service !== undefined) {
      url += `&service=${config.service}`;
    }

    url += `&client=${config.client}&cache=` + Date.now();

    return await axios
      .get(url)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  getEvents({ state }) {
    const user = JSON.parse(localStorage.user);
    const url =
      `withCredentials/collab/configurationEvenements?cache=` + Date.now();
    // const url = `withCredentials/collab/configurationEvenements?restaurantId=80041`;

    return (
      axios
        .get(url)
        // method: "get",
        // url,
        // baseURL: "https://testcollab.cashsystemes.com/",
        // })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          return Promise.reject(error);
        })
    );
  },
  addEvents({ state }, event) {
    // const url = `withCredentials/collab/addEvenementLocal?restaurantId=80041`;
    const url = `withCredentials/collab/addEvenementLocal`;
    return (
      axios
        .put(url, event)
        // method: "put",
        // url,
        // baseURL: "https://testcollab.cashsystemes.com/",
        // data: event
        // })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          return Promise.reject(error);
        })
    );
  },
  async getResumeData({ state, commit }, { restaurantIds, datesFiscales, forceRefresh = false }) {
    // Créer une clé de cache basée sur les paramètres
    const cacheKey = `${restaurantIds}_${datesFiscales}`;

    // Vérifier si les données sont déjà en cache et pas forcées de se rafraîchir
    if (state.resumeDataCache && state.resumeDataCache[cacheKey] && !forceRefresh) {
      return state.resumeDataCache[cacheKey];
    }

    const url = `bo/home/V2/getResumeData?restaurantIds=${restaurantIds}&datesFiscales=${datesFiscales}`;

    return await axios
      .get(url)
      .then((response) => {
        // Stocker en cache
        commit("SET_RESUME_DATA_CACHE", { key: cacheKey, data: response.data });
        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  addPerim({ state }, event) {
    const url = `withCredentials/collab/addEvenementLocal`;
    return axios
      .put(url, { perim_affects: event })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  updateEvents({ state }, event) {
    // const url = `withCredentials/collab/changeEvenementLocal?restaurantId=80041`;
    const url = `withCredentials/collab/changeEvenementLocal`;
    // console.log(event);
    return (
      axios
        .post(url, event)
        // method: "post",
        // url,
        // baseURL: "https://testcollab.cashsystemes.com/",
        // data: event
        // })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          return Promise.reject(error);
        })
    );
  },
  deleteEvents({ state }, event) {
    const user = JSON.parse(localStorage.user);
    console.log(event);
    const url = `withCredentials/collab/deleteEvenementLocal?evenement=${event.uuid_evt}`;
    return axios
      .delete(url, event)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  getPrev({ state }) {
    const user = JSON.parse(localStorage.user);
    const url = `withCredentials/collab/previsions?cache=` + Date.now();

    return axios
      .get(url)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
};
